var cov_1295o4djk3 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/TreeSelect.tsx",
      hash = "a74bc637f7567decb87bd96d0156e2ce0bd7eab9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/TreeSelect.tsx",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 44
        },
        end: {
          line: 32,
          column: 45
        }
      },
      "2": {
        start: {
          line: 38,
          column: 18
        },
        end: {
          line: 38,
          column: 51
        }
      },
      "3": {
        start: {
          line: 42,
          column: 19
        },
        end: {
          line: 42,
          column: 111
        }
      },
      "4": {
        start: {
          line: 42,
          column: 73
        },
        end: {
          line: 42,
          column: 110
        }
      },
      "5": {
        start: {
          line: 44,
          column: 21
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "6": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "7": {
        start: {
          line: 45,
          column: 41
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "8": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 37
        }
      },
      "9": {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 37
        }
      },
      "10": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 43
        }
      },
      "11": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 16
        }
      },
      "12": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "13": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 51
        }
      },
      "14": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 58
        }
      },
      "15": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 60
        }
      },
      "16": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 54
        }
      },
      "17": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 52
        }
      },
      "18": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 52
        }
      },
      "19": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 48
        }
      },
      "20": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 50
        }
      },
      "21": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 56
        }
      },
      "22": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 50
        }
      },
      "23": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 54
        }
      },
      "24": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 56
        }
      },
      "25": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 50
        }
      },
      "26": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 52
        }
      },
      "27": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 58
        }
      },
      "28": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 50
        }
      },
      "29": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 58
        }
      },
      "30": {
        start: {
          line: 97,
          column: 52
        },
        end: {
          line: 99,
          column: 5
        }
      },
      "31": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "32": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 105,
          column: 7
        }
      },
      "33": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 102,
          column: 43
        }
      },
      "34": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 52
        }
      },
      "35": {
        start: {
          line: 110,
          column: 38
        },
        end: {
          line: 110,
          column: 48
        }
      },
      "36": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 21
        }
      },
      "37": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 119,
          column: 5
        }
      },
      "38": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 118,
          column: 13
        }
      },
      "39": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 28
        }
      },
      "40": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 32
        }
      },
      "41": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 25
        }
      },
      "42": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "43": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 131,
          column: 8
        }
      },
      "44": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 44
        }
      },
      "45": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "46": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 34
        }
      },
      "47": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 45
        }
      },
      "48": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 24
        }
      },
      "49": {
        start: {
          line: 147,
          column: 32
        },
        end: {
          line: 147,
          column: 42
        }
      },
      "50": {
        start: {
          line: 148,
          column: 18
        },
        end: {
          line: 148,
          column: 34
        }
      },
      "51": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 39
        }
      },
      "52": {
        start: {
          line: 149,
          column: 18
        },
        end: {
          line: 149,
          column: 39
        }
      },
      "53": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 50
        }
      },
      "54": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 59
        }
      },
      "55": {
        start: {
          line: 154,
          column: 47
        },
        end: {
          line: 154,
          column: 59
        }
      },
      "56": {
        start: {
          line: 155,
          column: 32
        },
        end: {
          line: 155,
          column: 42
        }
      },
      "57": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 158,
          column: 5
        }
      },
      "58": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 51
        }
      },
      "59": {
        start: {
          line: 157,
          column: 29
        },
        end: {
          line: 157,
          column: 50
        }
      },
      "60": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 45
        }
      },
      "61": {
        start: {
          line: 164,
          column: 22
        },
        end: {
          line: 164,
          column: 32
        }
      },
      "62": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "63": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 62
        }
      },
      "64": {
        start: {
          line: 166,
          column: 30
        },
        end: {
          line: 166,
          column: 51
        }
      },
      "65": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 46
        }
      },
      "66": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 43
        }
      },
      "67": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 21
        }
      },
      "68": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 69
        }
      },
      "69": {
        start: {
          line: 180,
          column: 58
        },
        end: {
          line: 180,
          column: 69
        }
      },
      "70": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 181,
          column: 86
        }
      },
      "71": {
        start: {
          line: 181,
          column: 75
        },
        end: {
          line: 181,
          column: 86
        }
      },
      "72": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 182,
          column: 16
        }
      },
      "73": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 186,
          column: 64
        }
      },
      "74": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 190,
          column: 67
        }
      },
      "75": {
        start: {
          line: 194,
          column: 17
        },
        end: {
          line: 194,
          column: 58
        }
      },
      "76": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 199,
          column: 5
        }
      },
      "77": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 27
        }
      },
      "78": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 26
        }
      },
      "79": {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 198,
          column: 32
        }
      },
      "80": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 203,
          column: 44
        }
      },
      "81": {
        start: {
          line: 203,
          column: 38
        },
        end: {
          line: 203,
          column: 44
        }
      },
      "82": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 42
        }
      },
      "83": {
        start: {
          line: 204,
          column: 36
        },
        end: {
          line: 204,
          column: 42
        }
      },
      "84": {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 206,
          column: 103
        }
      },
      "85": {
        start: {
          line: 206,
          column: 97
        },
        end: {
          line: 206,
          column: 103
        }
      },
      "86": {
        start: {
          line: 208,
          column: 57
        },
        end: {
          line: 208,
          column: 67
        }
      },
      "87": {
        start: {
          line: 209,
          column: 23
        },
        end: {
          line: 209,
          column: 33
        }
      },
      "88": {
        start: {
          line: 210,
          column: 25
        },
        end: {
          line: 210,
          column: 39
        }
      },
      "89": {
        start: {
          line: 211,
          column: 19
        },
        end: {
          line: 211,
          column: 71
        }
      },
      "90": {
        start: {
          line: 212,
          column: 4
        },
        end: {
          line: 212,
          column: 64
        }
      },
      "91": {
        start: {
          line: 212,
          column: 44
        },
        end: {
          line: 212,
          column: 64
        }
      },
      "92": {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 214,
          column: 37
        }
      },
      "93": {
        start: {
          line: 214,
          column: 20
        },
        end: {
          line: 214,
          column: 37
        }
      },
      "94": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 63
        }
      },
      "95": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 220,
          column: 5
        }
      },
      "96": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 26
        }
      },
      "97": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 224,
          column: 43
        }
      },
      "98": {
        start: {
          line: 224,
          column: 37
        },
        end: {
          line: 224,
          column: 43
        }
      },
      "99": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 25
        }
      },
      "100": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 24
        }
      },
      "101": {
        start: {
          line: 230,
          column: 30
        },
        end: {
          line: 230,
          column: 40
        }
      },
      "102": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 241,
          column: 5
        }
      },
      "103": {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 24
        }
      },
      "104": {
        start: {
          line: 234,
          column: 6
        },
        end: {
          line: 240,
          column: 7
        }
      },
      "105": {
        start: {
          line: 235,
          column: 8
        },
        end: {
          line: 238,
          column: 9
        }
      },
      "106": {
        start: {
          line: 236,
          column: 26
        },
        end: {
          line: 236,
          column: 42
        }
      },
      "107": {
        start: {
          line: 237,
          column: 10
        },
        end: {
          line: 237,
          column: 39
        }
      },
      "108": {
        start: {
          line: 237,
          column: 33
        },
        end: {
          line: 237,
          column: 39
        }
      },
      "109": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 239,
          column: 30
        }
      },
      "110": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 252,
          column: 5
        }
      },
      "111": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 25
        }
      },
      "112": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 251,
          column: 7
        }
      },
      "113": {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 248,
          column: 34
        }
      },
      "114": {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 29
        }
      },
      "115": {
        start: {
          line: 256,
          column: 22
        },
        end: {
          line: 256,
          column: 32
        }
      },
      "116": {
        start: {
          line: 257,
          column: 20
        },
        end: {
          line: 257,
          column: 111
        }
      },
      "117": {
        start: {
          line: 258,
          column: 4
        },
        end: {
          line: 258,
          column: 35
        }
      },
      "118": {
        start: {
          line: 259,
          column: 4
        },
        end: {
          line: 259,
          column: 63
        }
      },
      "119": {
        start: {
          line: 263,
          column: 70
        },
        end: {
          line: 263,
          column: 80
        }
      },
      "120": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 57
        }
      },
      "121": {
        start: {
          line: 264,
          column: 51
        },
        end: {
          line: 264,
          column: 57
        }
      },
      "122": {
        start: {
          line: 265,
          column: 20
        },
        end: {
          line: 265,
          column: 49
        }
      },
      "123": {
        start: {
          line: 266,
          column: 4
        },
        end: {
          line: 270,
          column: 5
        }
      },
      "124": {
        start: {
          line: 267,
          column: 6
        },
        end: {
          line: 267,
          column: 24
        }
      },
      "125": {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 268,
          column: 38
        }
      },
      "126": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 269,
          column: 29
        }
      },
      "127": {
        start: {
          line: 271,
          column: 18
        },
        end: {
          line: 271,
          column: 33
        }
      },
      "128": {
        start: {
          line: 272,
          column: 4
        },
        end: {
          line: 272,
          column: 91
        }
      },
      "129": {
        start: {
          line: 272,
          column: 18
        },
        end: {
          line: 272,
          column: 91
        }
      },
      "130": {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 280,
          column: 5
        }
      },
      "131": {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 279,
          column: 8
        }
      },
      "132": {
        start: {
          line: 284,
          column: 43
        },
        end: {
          line: 284,
          column: 53
        }
      },
      "133": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 285,
          column: 33
        }
      },
      "134": {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 286,
          column: 54
        }
      },
      "135": {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 291,
          column: 5
        }
      },
      "136": {
        start: {
          line: 288,
          column: 6
        },
        end: {
          line: 290,
          column: 8
        }
      },
      "137": {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 292,
          column: 27
        }
      },
      "138": {
        start: {
          line: 293,
          column: 4
        },
        end: {
          line: 293,
          column: 24
        }
      },
      "139": {
        start: {
          line: 298,
          column: 27
        },
        end: {
          line: 298,
          column: 37
        }
      },
      "140": {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 299,
          column: 104
        }
      },
      "141": {
        start: {
          line: 303,
          column: 34
        },
        end: {
          line: 303,
          column: 44
        }
      },
      "142": {
        start: {
          line: 304,
          column: 17
        },
        end: {
          line: 306,
          column: 58
        }
      },
      "143": {
        start: {
          line: 308,
          column: 4
        },
        end: {
          line: 319,
          column: 5
        }
      },
      "144": {
        start: {
          line: 323,
          column: 32
        },
        end: {
          line: 323,
          column: 42
        }
      },
      "145": {
        start: {
          line: 324,
          column: 83
        },
        end: {
          line: 324,
          column: 93
        }
      },
      "146": {
        start: {
          line: 325,
          column: 45
        },
        end: {
          line: 325,
          column: 47
        }
      },
      "147": {
        start: {
          line: 326,
          column: 40
        },
        end: {
          line: 342,
          column: 5
        }
      },
      "148": {
        start: {
          line: 344,
          column: 4
        },
        end: {
          line: 346,
          column: 6
        }
      },
      "149": {
        start: {
          line: 345,
          column: 7
        },
        end: {
          line: 345,
          column: 40
        }
      },
      "150": {
        start: {
          line: 347,
          column: 4
        },
        end: {
          line: 347,
          column: 53
        }
      },
      "151": {
        start: {
          line: 348,
          column: 4
        },
        end: {
          line: 355,
          column: 5
        }
      },
      "152": {
        start: {
          line: 350,
          column: 6
        },
        end: {
          line: 350,
          column: 40
        }
      },
      "153": {
        start: {
          line: 352,
          column: 6
        },
        end: {
          line: 352,
          column: 39
        }
      },
      "154": {
        start: {
          line: 353,
          column: 6
        },
        end: {
          line: 353,
          column: 42
        }
      },
      "155": {
        start: {
          line: 354,
          column: 6
        },
        end: {
          line: 354,
          column: 68
        }
      },
      "156": {
        start: {
          line: 357,
          column: 6
        },
        end: {
          line: 366,
          column: 7
        }
      },
      "157": {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 384,
          column: 5
        }
      },
      "158": {
        start: {
          line: 404,
          column: 8
        },
        end: {
          line: 404,
          column: 18
        }
      },
      "159": {
        start: {
          line: 405,
          column: 22
        },
        end: {
          line: 412,
          column: 5
        }
      },
      "160": {
        start: {
          line: 413,
          column: 25
        },
        end: {
          line: 413,
          column: 67
        }
      },
      "161": {
        start: {
          line: 415,
          column: 4
        },
        end: {
          line: 448,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 16
          }
        },
        loc: {
          start: {
            line: 32,
            column: 44
          },
          end: {
            line: 32,
            column: 45
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 32
          },
          end: {
            line: 42,
            column: 33
          }
        },
        loc: {
          start: {
            line: 42,
            column: 73
          },
          end: {
            line: 42,
            column: 110
          }
        },
        line: 42
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 44,
            column: 22
          }
        },
        loc: {
          start: {
            line: 44,
            column: 59
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 57
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 73
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 97
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 109
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 116,
            column: 17
          },
          end: {
            line: 116,
            column: 18
          }
        },
        loc: {
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 118,
            column: 7
          }
        },
        line: 116
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 3
          }
        },
        loc: {
          start: {
            line: 122,
            column: 25
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 122
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 34
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 127
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 129,
            column: 17
          },
          end: {
            line: 129,
            column: 18
          }
        },
        loc: {
          start: {
            line: 129,
            column: 23
          },
          end: {
            line: 131,
            column: 7
          }
        },
        line: 129
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 3
          }
        },
        loc: {
          start: {
            line: 138,
            column: 23
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 138
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 142,
            column: 2
          },
          end: {
            line: 142,
            column: 3
          }
        },
        loc: {
          start: {
            line: 142,
            column: 47
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 142
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 13
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 146
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 3
          }
        },
        loc: {
          start: {
            line: 153,
            column: 56
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 153
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 157,
            column: 23
          },
          end: {
            line: 157,
            column: 24
          }
        },
        loc: {
          start: {
            line: 157,
            column: 29
          },
          end: {
            line: 157,
            column: 50
          }
        },
        line: 157
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 162,
            column: 2
          },
          end: {
            line: 162,
            column: 3
          }
        },
        loc: {
          start: {
            line: 162,
            column: 33
          },
          end: {
            line: 169,
            column: 3
          }
        },
        line: 162
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 166,
            column: 24
          },
          end: {
            line: 166,
            column: 25
          }
        },
        loc: {
          start: {
            line: 166,
            column: 30
          },
          end: {
            line: 166,
            column: 51
          }
        },
        line: 166
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 3
          }
        },
        loc: {
          start: {
            line: 171,
            column: 54
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 171
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        loc: {
          start: {
            line: 175,
            column: 34
          },
          end: {
            line: 177,
            column: 3
          }
        },
        line: 175
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 179,
            column: 3
          }
        },
        loc: {
          start: {
            line: 179,
            column: 34
          },
          end: {
            line: 183,
            column: 3
          }
        },
        line: 179
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 185,
            column: 2
          },
          end: {
            line: 185,
            column: 3
          }
        },
        loc: {
          start: {
            line: 185,
            column: 18
          },
          end: {
            line: 187,
            column: 3
          }
        },
        line: 185
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 189,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        loc: {
          start: {
            line: 189,
            column: 19
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 189
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 193,
            column: 2
          },
          end: {
            line: 193,
            column: 3
          }
        },
        loc: {
          start: {
            line: 193,
            column: 26
          },
          end: {
            line: 200,
            column: 3
          }
        },
        line: 193
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 202,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        },
        loc: {
          start: {
            line: 202,
            column: 39
          },
          end: {
            line: 221,
            column: 3
          }
        },
        line: 202
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        },
        loc: {
          start: {
            line: 223,
            column: 51
          },
          end: {
            line: 227,
            column: 3
          }
        },
        line: 223
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 229,
            column: 2
          },
          end: {
            line: 229,
            column: 3
          }
        },
        loc: {
          start: {
            line: 229,
            column: 56
          },
          end: {
            line: 253,
            column: 3
          }
        },
        line: 229
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 255,
            column: 2
          },
          end: {
            line: 255,
            column: 3
          }
        },
        loc: {
          start: {
            line: 255,
            column: 39
          },
          end: {
            line: 260,
            column: 3
          }
        },
        line: 255
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 262,
            column: 2
          },
          end: {
            line: 262,
            column: 3
          }
        },
        loc: {
          start: {
            line: 262,
            column: 48
          },
          end: {
            line: 281,
            column: 3
          }
        },
        line: 262
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 283,
            column: 2
          },
          end: {
            line: 283,
            column: 3
          }
        },
        loc: {
          start: {
            line: 283,
            column: 16
          },
          end: {
            line: 294,
            column: 3
          }
        },
        line: 283
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 297,
            column: 2
          },
          end: {
            line: 297,
            column: 3
          }
        },
        loc: {
          start: {
            line: 297,
            column: 25
          },
          end: {
            line: 300,
            column: 3
          }
        },
        line: 297
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 302,
            column: 2
          },
          end: {
            line: 302,
            column: 3
          }
        },
        loc: {
          start: {
            line: 302,
            column: 81
          },
          end: {
            line: 320,
            column: 3
          }
        },
        line: 302
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 322,
            column: 2
          },
          end: {
            line: 322,
            column: 3
          }
        },
        loc: {
          start: {
            line: 322,
            column: 22
          },
          end: {
            line: 385,
            column: 3
          }
        },
        line: 322
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 344,
            column: 21
          },
          end: {
            line: 344,
            column: 22
          }
        },
        loc: {
          start: {
            line: 344,
            column: 49
          },
          end: {
            line: 346,
            column: 5
          }
        },
        line: 344
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 387,
            column: 2
          },
          end: {
            line: 387,
            column: 3
          }
        },
        loc: {
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 449,
            column: 3
          }
        },
        line: 387
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 52
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 52
          }
        }],
        line: 45
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 37
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 37
          }
        }],
        line: 46
      },
      "2": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 100
      },
      "3": {
        loc: {
          start: {
            line: 101,
            column: 6
          },
          end: {
            line: 105,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 6
          },
          end: {
            line: 105,
            column: 7
          }
        }, {
          start: {
            line: 101,
            column: 6
          },
          end: {
            line: 105,
            column: 7
          }
        }],
        line: 101
      },
      "4": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 119,
            column: 5
          }
        }],
        line: 115
      },
      "5": {
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 44
          }
        }, {
          start: {
            line: 115,
            column: 48
          },
          end: {
            line: 115,
            column: 65
          }
        }, {
          start: {
            line: 115,
            column: 69
          },
          end: {
            line: 115,
            column: 77
          }
        }],
        line: 115
      },
      "6": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }, {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }],
        line: 128
      },
      "7": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 133
      },
      "8": {
        loc: {
          start: {
            line: 139,
            column: 11
          },
          end: {
            line: 139,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 11
          },
          end: {
            line: 139,
            column: 27
          }
        }, {
          start: {
            line: 139,
            column: 31
          },
          end: {
            line: 139,
            column: 45
          }
        }],
        line: 139
      },
      "9": {
        loc: {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 39
          }
        }, {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 39
          }
        }],
        line: 149
      },
      "10": {
        loc: {
          start: {
            line: 150,
            column: 12
          },
          end: {
            line: 150,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 150,
            column: 27
          },
          end: {
            line: 150,
            column: 35
          }
        }, {
          start: {
            line: 150,
            column: 38
          },
          end: {
            line: 150,
            column: 40
          }
        }],
        line: 150
      },
      "11": {
        loc: {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 59
          }
        }, {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 154,
            column: 59
          }
        }],
        line: 154
      },
      "12": {
        loc: {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 154,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 154,
            column: 22
          }
        }, {
          start: {
            line: 154,
            column: 26
          },
          end: {
            line: 154,
            column: 45
          }
        }],
        line: 154
      },
      "13": {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }],
        line: 156
      },
      "14": {
        loc: {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 156,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 156,
            column: 16
          }
        }, {
          start: {
            line: 156,
            column: 20
          },
          end: {
            line: 156,
            column: 40
          }
        }],
        line: 156
      },
      "15": {
        loc: {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }],
        line: 165
      },
      "16": {
        loc: {
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 69
          }
        }, {
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 69
          }
        }],
        line: 180
      },
      "17": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 181,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 181,
            column: 86
          }
        }, {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 181,
            column: 86
          }
        }],
        line: 181
      },
      "18": {
        loc: {
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 199,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 199,
            column: 5
          }
        }, {
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 199,
            column: 5
          }
        }],
        line: 195
      },
      "19": {
        loc: {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 44
          }
        }, {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 44
          }
        }],
        line: 203
      },
      "20": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 42
          }
        }, {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 42
          }
        }],
        line: 204
      },
      "21": {
        loc: {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 206,
            column: 103
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 206,
            column: 103
          }
        }, {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 206,
            column: 103
          }
        }],
        line: 206
      },
      "22": {
        loc: {
          start: {
            line: 206,
            column: 8
          },
          end: {
            line: 206,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 206,
            column: 8
          },
          end: {
            line: 206,
            column: 13
          }
        }, {
          start: {
            line: 206,
            column: 17
          },
          end: {
            line: 206,
            column: 18
          }
        }, {
          start: {
            line: 206,
            column: 22
          },
          end: {
            line: 206,
            column: 95
          }
        }],
        line: 206
      },
      "23": {
        loc: {
          start: {
            line: 208,
            column: 12
          },
          end: {
            line: 208,
            column: 40
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 208,
            column: 21
          },
          end: {
            line: 208,
            column: 40
          }
        }],
        line: 208
      },
      "24": {
        loc: {
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 212,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 212,
            column: 64
          }
        }, {
          start: {
            line: 212,
            column: 4
          },
          end: {
            line: 212,
            column: 64
          }
        }],
        line: 212
      },
      "25": {
        loc: {
          start: {
            line: 212,
            column: 8
          },
          end: {
            line: 212,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 8
          },
          end: {
            line: 212,
            column: 29
          }
        }, {
          start: {
            line: 212,
            column: 33
          },
          end: {
            line: 212,
            column: 42
          }
        }],
        line: 212
      },
      "26": {
        loc: {
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 214,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 214,
            column: 37
          }
        }, {
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 214,
            column: 37
          }
        }],
        line: 214
      },
      "27": {
        loc: {
          start: {
            line: 215,
            column: 37
          },
          end: {
            line: 215,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 215,
            column: 37
          },
          end: {
            line: 215,
            column: 45
          }
        }, {
          start: {
            line: 215,
            column: 49
          },
          end: {
            line: 215,
            column: 60
          }
        }],
        line: 215
      },
      "28": {
        loc: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        }, {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 220,
            column: 5
          }
        }],
        line: 217
      },
      "29": {
        loc: {
          start: {
            line: 224,
            column: 4
          },
          end: {
            line: 224,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 224,
            column: 4
          },
          end: {
            line: 224,
            column: 43
          }
        }, {
          start: {
            line: 224,
            column: 4
          },
          end: {
            line: 224,
            column: 43
          }
        }],
        line: 224
      },
      "30": {
        loc: {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 241,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 241,
            column: 5
          }
        }, {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 241,
            column: 5
          }
        }],
        line: 231
      },
      "31": {
        loc: {
          start: {
            line: 234,
            column: 6
          },
          end: {
            line: 240,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 234,
            column: 6
          },
          end: {
            line: 240,
            column: 7
          }
        }, {
          start: {
            line: 234,
            column: 6
          },
          end: {
            line: 240,
            column: 7
          }
        }],
        line: 234
      },
      "32": {
        loc: {
          start: {
            line: 235,
            column: 8
          },
          end: {
            line: 238,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 235,
            column: 8
          },
          end: {
            line: 238,
            column: 9
          }
        }, {
          start: {
            line: 235,
            column: 8
          },
          end: {
            line: 238,
            column: 9
          }
        }],
        line: 235
      },
      "33": {
        loc: {
          start: {
            line: 237,
            column: 10
          },
          end: {
            line: 237,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 237,
            column: 10
          },
          end: {
            line: 237,
            column: 39
          }
        }, {
          start: {
            line: 237,
            column: 10
          },
          end: {
            line: 237,
            column: 39
          }
        }],
        line: 237
      },
      "34": {
        loc: {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 252,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 252,
            column: 5
          }
        }, {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 252,
            column: 5
          }
        }],
        line: 244
      },
      "35": {
        loc: {
          start: {
            line: 247,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }, {
          start: {
            line: 247,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }],
        line: 247
      },
      "36": {
        loc: {
          start: {
            line: 257,
            column: 20
          },
          end: {
            line: 257,
            column: 111
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 257,
            column: 52
          },
          end: {
            line: 257,
            column: 82
          }
        }, {
          start: {
            line: 257,
            column: 85
          },
          end: {
            line: 257,
            column: 111
          }
        }],
        line: 257
      },
      "37": {
        loc: {
          start: {
            line: 257,
            column: 20
          },
          end: {
            line: 257,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 257,
            column: 20
          },
          end: {
            line: 257,
            column: 24
          }
        }, {
          start: {
            line: 257,
            column: 28
          },
          end: {
            line: 257,
            column: 49
          }
        }],
        line: 257
      },
      "38": {
        loc: {
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 264,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 264,
            column: 57
          }
        }, {
          start: {
            line: 264,
            column: 4
          },
          end: {
            line: 264,
            column: 57
          }
        }],
        line: 264
      },
      "39": {
        loc: {
          start: {
            line: 264,
            column: 8
          },
          end: {
            line: 264,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 264,
            column: 8
          },
          end: {
            line: 264,
            column: 25
          }
        }, {
          start: {
            line: 264,
            column: 29
          },
          end: {
            line: 264,
            column: 49
          }
        }],
        line: 264
      },
      "40": {
        loc: {
          start: {
            line: 266,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 266,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        }, {
          start: {
            line: 266,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        }],
        line: 266
      },
      "41": {
        loc: {
          start: {
            line: 272,
            column: 4
          },
          end: {
            line: 272,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 272,
            column: 4
          },
          end: {
            line: 272,
            column: 91
          }
        }, {
          start: {
            line: 272,
            column: 4
          },
          end: {
            line: 272,
            column: 91
          }
        }],
        line: 272
      },
      "42": {
        loc: {
          start: {
            line: 272,
            column: 43
          },
          end: {
            line: 272,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 272,
            column: 48
          },
          end: {
            line: 272,
            column: 78
          }
        }, {
          start: {
            line: 272,
            column: 81
          },
          end: {
            line: 272,
            column: 90
          }
        }],
        line: 272
      },
      "43": {
        loc: {
          start: {
            line: 272,
            column: 49
          },
          end: {
            line: 272,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 272,
            column: 49
          },
          end: {
            line: 272,
            column: 66
          }
        }, {
          start: {
            line: 272,
            column: 70
          },
          end: {
            line: 272,
            column: 72
          }
        }],
        line: 272
      },
      "44": {
        loc: {
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 280,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 280,
            column: 5
          }
        }, {
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 280,
            column: 5
          }
        }],
        line: 274
      },
      "45": {
        loc: {
          start: {
            line: 277,
            column: 17
          },
          end: {
            line: 277,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 277,
            column: 28
          },
          end: {
            line: 277,
            column: 41
          }
        }, {
          start: {
            line: 277,
            column: 44
          },
          end: {
            line: 277,
            column: 53
          }
        }],
        line: 277
      },
      "46": {
        loc: {
          start: {
            line: 286,
            column: 25
          },
          end: {
            line: 286,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 286,
            column: 36
          },
          end: {
            line: 286,
            column: 38
          }
        }, {
          start: {
            line: 286,
            column: 41
          },
          end: {
            line: 286,
            column: 43
          }
        }],
        line: 286
      },
      "47": {
        loc: {
          start: {
            line: 287,
            column: 4
          },
          end: {
            line: 291,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 287,
            column: 4
          },
          end: {
            line: 291,
            column: 5
          }
        }, {
          start: {
            line: 287,
            column: 4
          },
          end: {
            line: 291,
            column: 5
          }
        }],
        line: 287
      },
      "48": {
        loc: {
          start: {
            line: 289,
            column: 14
          },
          end: {
            line: 289,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 289,
            column: 25
          },
          end: {
            line: 289,
            column: 27
          }
        }, {
          start: {
            line: 289,
            column: 30
          },
          end: {
            line: 289,
            column: 34
          }
        }],
        line: 289
      },
      "49": {
        loc: {
          start: {
            line: 299,
            column: 11
          },
          end: {
            line: 299,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 299,
            column: 46
          },
          end: {
            line: 299,
            column: 71
          }
        }, {
          start: {
            line: 299,
            column: 74
          },
          end: {
            line: 299,
            column: 104
          }
        }],
        line: 299
      },
      "50": {
        loc: {
          start: {
            line: 304,
            column: 18
          },
          end: {
            line: 306,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 305,
            column: 8
          },
          end: {
            line: 305,
            column: 46
          }
        }, {
          start: {
            line: 306,
            column: 8
          },
          end: {
            line: 306,
            column: 38
          }
        }],
        line: 304
      },
      "51": {
        loc: {
          start: {
            line: 310,
            column: 15
          },
          end: {
            line: 310,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 310,
            column: 42
          },
          end: {
            line: 310,
            column: 46
          }
        }, {
          start: {
            line: 310,
            column: 49
          },
          end: {
            line: 310,
            column: 58
          }
        }],
        line: 310
      },
      "52": {
        loc: {
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 313,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 313,
            column: 16
          }
        }, {
          start: {
            line: 313,
            column: 20
          },
          end: {
            line: 313,
            column: 30
          }
        }],
        line: 313
      },
      "53": {
        loc: {
          start: {
            line: 314,
            column: 10
          },
          end: {
            line: 314,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 314,
            column: 10
          },
          end: {
            line: 314,
            column: 46
          }
        }, {
          start: {
            line: 314,
            column: 50
          },
          end: {
            line: 314,
            column: 79
          }
        }],
        line: 314
      },
      "54": {
        loc: {
          start: {
            line: 348,
            column: 4
          },
          end: {
            line: 355,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 348,
            column: 4
          },
          end: {
            line: 355,
            column: 5
          }
        }, {
          start: {
            line: 348,
            column: 4
          },
          end: {
            line: 355,
            column: 5
          }
        }],
        line: 348
      },
      "55": {
        loc: {
          start: {
            line: 354,
            column: 21
          },
          end: {
            line: 354,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 354,
            column: 42
          },
          end: {
            line: 354,
            column: 56
          }
        }, {
          start: {
            line: 354,
            column: 59
          },
          end: {
            line: 354,
            column: 68
          }
        }],
        line: 354
      },
      "56": {
        loc: {
          start: {
            line: 357,
            column: 6
          },
          end: {
            line: 366,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 358,
            column: 8
          },
          end: {
            line: 358,
            column: 102
          }
        }, {
          start: {
            line: 360,
            column: 8
          },
          end: {
            line: 365,
            column: 10
          }
        }],
        line: 357
      },
      "57": {
        loc: {
          start: {
            line: 361,
            column: 37
          },
          end: {
            line: 361,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 361,
            column: 37
          },
          end: {
            line: 361,
            column: 46
          }
        }, {
          start: {
            line: 361,
            column: 50
          },
          end: {
            line: 361,
            column: 58
          }
        }],
        line: 361
      },
      "58": {
        loc: {
          start: {
            line: 371,
            column: 45
          },
          end: {
            line: 371,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 371,
            column: 45
          },
          end: {
            line: 371,
            column: 52
          }
        }, {
          start: {
            line: 371,
            column: 56
          },
          end: {
            line: 371,
            column: 61
          }
        }],
        line: 371
      },
      "59": {
        loc: {
          start: {
            line: 380,
            column: 15
          },
          end: {
            line: 380,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 380,
            column: 41
          },
          end: {
            line: 380,
            column: 46
          }
        }, {
          start: {
            line: 380,
            column: 49
          },
          end: {
            line: 380,
            column: 58
          }
        }],
        line: 380
      },
      "60": {
        loc: {
          start: {
            line: 380,
            column: 15
          },
          end: {
            line: 380,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 380,
            column: 15
          },
          end: {
            line: 380,
            column: 23
          }
        }, {
          start: {
            line: 380,
            column: 27
          },
          end: {
            line: 380,
            column: 38
          }
        }],
        line: 380
      },
      "61": {
        loc: {
          start: {
            line: 408,
            column: 6
          },
          end: {
            line: 408,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 408,
            column: 6
          },
          end: {
            line: 408,
            column: 22
          }
        }, {
          start: {
            line: 408,
            column: 26
          },
          end: {
            line: 408,
            column: 33
          }
        }],
        line: 408
      },
      "62": {
        loc: {
          start: {
            line: 410,
            column: 6
          },
          end: {
            line: 410,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 410,
            column: 6
          },
          end: {
            line: 410,
            column: 14
          }
        }, {
          start: {
            line: 410,
            column: 18
          },
          end: {
            line: 410,
            column: 28
          }
        }],
        line: 410
      },
      "63": {
        loc: {
          start: {
            line: 411,
            column: 6
          },
          end: {
            line: 411,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 411,
            column: 6
          },
          end: {
            line: 411,
            column: 23
          }
        }, {
          start: {
            line: 411,
            column: 27
          },
          end: {
            line: 411,
            column: 56
          }
        }],
        line: 411
      },
      "64": {
        loc: {
          start: {
            line: 413,
            column: 25
          },
          end: {
            line: 413,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 413,
            column: 25
          },
          end: {
            line: 413,
            column: 48
          }
        }, {
          start: {
            line: 413,
            column: 52
          },
          end: {
            line: 413,
            column: 67
          }
        }],
        line: 413
      },
      "65": {
        loc: {
          start: {
            line: 418,
            column: 18
          },
          end: {
            line: 418,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 418,
            column: 38
          },
          end: {
            line: 418,
            column: 40
          }
        }, {
          start: {
            line: 418,
            column: 43
          },
          end: {
            line: 418,
            column: 44
          }
        }],
        line: 418
      },
      "66": {
        loc: {
          start: {
            line: 428,
            column: 19
          },
          end: {
            line: 428,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 428,
            column: 31
          },
          end: {
            line: 428,
            column: 47
          }
        }, {
          start: {
            line: 428,
            column: 50
          },
          end: {
            line: 428,
            column: 59
          }
        }],
        line: 428
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0],
      "23": [0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/TreeSelect.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { isFunc, isArray } from '../utils/is';
import Tree from '../Tree';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import { treeSelectClass } from './styles';
import Result from './Result';
import absoluteList from '../AnimationList/AbsoluteList';
import { docSize } from '../utils/dom/document';
import { getParent } from '../utils/dom/element';
import List from '../AnimationList';
import { getLocale } from '../locale';
import { isRTL } from '../config';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = (cov_1295o4djk3.s[0]++, {
  clearable: false,
  compressed: false,
  absolute: false,
  multiple: false,
  line: false,
  renderItem: function renderItem(e) {
    cov_1295o4djk3.f[0]++;
    cov_1295o4djk3.s[1]++;
    return e;
  },
  height: 300,
  data: [],
  defaultExpanded: []
});
var ScaleList = (cov_1295o4djk3.s[2]++, List(['fade', 'scale-y'], 'fast'));
var OptionList = (cov_1295o4djk3.s[3]++, absoluteList(function (_ref) {
  var focus = _ref.focus,
      other = _objectWithoutProperties(_ref, ["focus"]);

  cov_1295o4djk3.f[1]++;
  cov_1295o4djk3.s[4]++;
  return (
    /*#__PURE__*/
    React.createElement(ScaleList, Object.assign({
      show: focus
    }, other, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 74
      }
    }))
  );
}));
cov_1295o4djk3.s[5]++;

var isDescendent = function isDescendent(el, id) {
  cov_1295o4djk3.f[2]++;
  cov_1295o4djk3.s[6]++;

  if (el.getAttribute('data-id') === id) {
    cov_1295o4djk3.b[0][0]++;
    cov_1295o4djk3.s[7]++;
    return true;
  } else {
    cov_1295o4djk3.b[0][1]++;
  }

  cov_1295o4djk3.s[8]++;

  if (!el.parentElement) {
    cov_1295o4djk3.b[1][0]++;
    cov_1295o4djk3.s[9]++;
    return false;
  } else {
    cov_1295o4djk3.b[1][1]++;
  }

  cov_1295o4djk3.s[10]++;
  return isDescendent(el.parentElement, id);
};

var TreeSelect =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TreeSelect, _PureComponent);

  var _super = _createSuper2(TreeSelect);

  function TreeSelect(props) {
    var _this2;

    _classCallCheck(this, TreeSelect);

    cov_1295o4djk3.f[3]++;
    cov_1295o4djk3.s[11]++;
    _this2 = _super.call(this, props);
    _this2.treeSelectId = void 0;
    _this2.handleClick = void 0;
    _this2.handleBlur = void 0;
    _this2.resetAbsoluteListPosition = void 0;
    _this2.inputReset = void 0;
    _this2.element = void 0;
    cov_1295o4djk3.s[12]++;
    _this2.state = {
      focus: false,
      position: 'drop-down'
    };
    cov_1295o4djk3.s[13]++;
    _this2.treeSelectId = "treeSelect_".concat(getUidStr());
    cov_1295o4djk3.s[14]++;
    _this2.onExpandHandler = _this2.onExpandHandler.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[15]++;
    _this2.getResetPosition = _this2.getResetPosition.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[16]++;
    _this2.setInputReset = _this2.setInputReset.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[17]++;
    _this2.renderActive = _this2.renderActive.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[18]++;
    _this2.handleChange = _this2.handleChange.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[19]++;
    _this2.renderItem = _this2.renderItem.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[20]++;
    _this2.bindElement = _this2.bindElement.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[21]++;
    _this2.handleClick = _this2.handleState.bind(_assertThisInitialized(_this2), true);
    cov_1295o4djk3.s[22]++;
    _this2.handleFocus = _this2.handleFocus.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[23]++;
    _this2.handleKeyDown = _this2.handleKeyDown.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[24]++;
    _this2.handleBlur = _this2.handleState.bind(_assertThisInitialized(_this2), false);
    cov_1295o4djk3.s[25]++;
    _this2.handleClear = _this2.handleClear.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[26]++;
    _this2.handleRemove = _this2.handleRemove.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[27]++;
    _this2.handleClickAway = _this2.handleClickAway.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[28]++;
    _this2.shouldFocus = _this2.shouldFocus.bind(_assertThisInitialized(_this2));
    cov_1295o4djk3.s[29]++;
    _this2.getDataByValues = _this2.getDataByValues.bind(_assertThisInitialized(_this2));
    var componentRef = (cov_1295o4djk3.s[30]++, {
      getDataByValues: _this2.getDataByValues
    });
    cov_1295o4djk3.s[31]++;

    if (props.getComponentRef) {
      cov_1295o4djk3.b[2][0]++;
      cov_1295o4djk3.s[32]++;

      if (isFunc(props.getComponentRef)) {
        cov_1295o4djk3.b[3][0]++;
        cov_1295o4djk3.s[33]++;
        props.getComponentRef(componentRef);
      } else {
        cov_1295o4djk3.b[3][1]++;
        cov_1295o4djk3.s[34]++;
        props.getComponentRef.current = componentRef;
      }
    } else {
      cov_1295o4djk3.b[2][1]++;
    }

    return _this2;
  }

  _createClass(TreeSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      cov_1295o4djk3.f[4]++;

      var _ref2 = (cov_1295o4djk3.s[35]++, this.props),
          onFilter = _ref2.onFilter,
          datum = _ref2.datum,
          mode = _ref2.mode;

      cov_1295o4djk3.s[36]++;
      datum.mode = mode; // clear filter

      cov_1295o4djk3.s[37]++;

      if ((cov_1295o4djk3.b[5][0]++, prevState.focus !== this.state.focus) && (cov_1295o4djk3.b[5][1]++, !this.state.focus) && (cov_1295o4djk3.b[5][2]++, onFilter)) {
        cov_1295o4djk3.b[4][0]++;
        cov_1295o4djk3.s[38]++;
        setTimeout(function () {
          cov_1295o4djk3.f[5]++;
          cov_1295o4djk3.s[39]++;
          onFilter('', 'blur');
        }, 400);
      } else {
        cov_1295o4djk3.b[4][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1295o4djk3.f[6]++;
      cov_1295o4djk3.s[40]++;

      _get(_getPrototypeOf(TreeSelect.prototype), "componentWillUnmount", this).call(this);

      cov_1295o4djk3.s[41]++;
      this.clearClickAway();
    }
  }, {
    key: "onExpandHandler",
    value: function onExpandHandler() {
      var _this3 = this;

      cov_1295o4djk3.f[7]++;
      cov_1295o4djk3.s[42]++;

      if (this.resetAbsoluteListPosition) {
        cov_1295o4djk3.b[6][0]++;
        cov_1295o4djk3.s[43]++;
        setTimeout(function () {
          cov_1295o4djk3.f[8]++;
          cov_1295o4djk3.s[44]++;

          _this3.resetAbsoluteListPosition(true);
        });
      } else {
        cov_1295o4djk3.b[6][1]++;
      }

      cov_1295o4djk3.s[45]++;

      if (this.props.onExpand) {
        var _this$props;

        cov_1295o4djk3.b[7][0]++;
        cov_1295o4djk3.s[46]++;

        (_this$props = this.props).onExpand.apply(_this$props, arguments);
      } else {
        cov_1295o4djk3.b[7][1]++;
      }
    }
  }, {
    key: "getText",
    value: function getText(key) {
      cov_1295o4djk3.f[9]++;
      cov_1295o4djk3.s[47]++;
      return (cov_1295o4djk3.b[8][0]++, this.props.empty) || (cov_1295o4djk3.b[8][1]++, getLocale(key));
    }
  }, {
    key: "setInputReset",
    value: function setInputReset(fn) {
      cov_1295o4djk3.f[10]++;
      cov_1295o4djk3.s[48]++;
      this.inputReset = fn;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      cov_1295o4djk3.f[11]++;

      var _ref3 = (cov_1295o4djk3.s[49]++, this.props),
          datum = _ref3.datum,
          multiple = _ref3.multiple;

      var value = (cov_1295o4djk3.s[50]++, datum.getValue());
      cov_1295o4djk3.s[51]++;

      if (multiple) {
        cov_1295o4djk3.b[9][0]++;
        cov_1295o4djk3.s[52]++;
        return value;
      } else {
        cov_1295o4djk3.b[9][1]++;
      }

      cov_1295o4djk3.s[53]++;
      return value.length ? (cov_1295o4djk3.b[10][0]++, value[0]) : (cov_1295o4djk3.b[10][1]++, '');
    }
  }, {
    key: "getDataByValue",
    value: function getDataByValue(value) {
      cov_1295o4djk3.f[12]++;
      cov_1295o4djk3.s[54]++;

      if ((cov_1295o4djk3.b[12][0]++, value === null) || (cov_1295o4djk3.b[12][1]++, value === undefined)) {
        cov_1295o4djk3.b[11][0]++;
        cov_1295o4djk3.s[55]++;
        return value;
      } else {
        cov_1295o4djk3.b[11][1]++;
      }

      var _ref4 = (cov_1295o4djk3.s[56]++, this.props),
          datum = _ref4.datum,
          multiple = _ref4.multiple;

      cov_1295o4djk3.s[57]++;

      if ((cov_1295o4djk3.b[14][0]++, multiple) && (cov_1295o4djk3.b[14][1]++, Array.isArray(value))) {
        cov_1295o4djk3.b[13][0]++;
        cov_1295o4djk3.s[58]++;
        return value.map(function (id) {
          cov_1295o4djk3.f[13]++;
          cov_1295o4djk3.s[59]++;
          return datum.getDataById(id);
        });
      } else {
        cov_1295o4djk3.b[13][1]++;
      }

      cov_1295o4djk3.s[60]++;
      return datum.getDataById(value);
    }
  }, {
    key: "getDataByValues",
    value: function getDataByValues(values) {
      cov_1295o4djk3.f[14]++;

      var _ref5 = (cov_1295o4djk3.s[61]++, this.props),
          datum = _ref5.datum;

      cov_1295o4djk3.s[62]++;

      if (isArray(values)) {
        cov_1295o4djk3.b[15][0]++;
        cov_1295o4djk3.s[63]++;
        return values.map(function (id) {
          cov_1295o4djk3.f[15]++;
          cov_1295o4djk3.s[64]++;
          return datum.getDataById(id);
        });
      } else {
        cov_1295o4djk3.b[15][1]++;
      }

      cov_1295o4djk3.s[65]++;
      return datum.getDataById(values);
    }
  }, {
    key: "getResetPosition",
    value: function getResetPosition(update) {
      cov_1295o4djk3.f[16]++;
      cov_1295o4djk3.s[66]++;
      this.resetAbsoluteListPosition = update;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1295o4djk3.f[17]++;
      cov_1295o4djk3.s[67]++;
      this.element = el;
    }
  }, {
    key: "shouldFocus",
    value: function shouldFocus(el) {
      cov_1295o4djk3.f[18]++;
      cov_1295o4djk3.s[68]++;

      if (el.getAttribute('data-id') === this.treeSelectId) {
        cov_1295o4djk3.b[16][0]++;
        cov_1295o4djk3.s[69]++;
        return true;
      } else {
        cov_1295o4djk3.b[16][1]++;
      }

      cov_1295o4djk3.s[70]++;

      if (getParent(el, ".".concat(treeSelectClass(getDirectionClass('result'))))) {
        cov_1295o4djk3.b[17][0]++;
        cov_1295o4djk3.s[71]++;
        return true;
      } else {
        cov_1295o4djk3.b[17][1]++;
      }

      cov_1295o4djk3.s[72]++;
      return false;
    }
  }, {
    key: "bindClickAway",
    value: function bindClickAway() {
      cov_1295o4djk3.f[19]++;
      cov_1295o4djk3.s[73]++;
      document.addEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "clearClickAway",
    value: function clearClickAway() {
      cov_1295o4djk3.f[20]++;
      cov_1295o4djk3.s[74]++;
      document.removeEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "handleClickAway",
    value: function handleClickAway(e) {
      cov_1295o4djk3.f[21]++;
      var desc = (cov_1295o4djk3.s[75]++, isDescendent(e.target, this.treeSelectId));
      cov_1295o4djk3.s[76]++;

      if (!desc) {
        cov_1295o4djk3.b[18][0]++;
        cov_1295o4djk3.s[77]++;
        this.clearClickAway();
        cov_1295o4djk3.s[78]++;
        this.props.onBlur(e);
        cov_1295o4djk3.s[79]++;
        this.handleState(false, e);
      } else {
        cov_1295o4djk3.b[18][1]++;
      }
    }
  }, {
    key: "handleState",
    value: function handleState(focus, e) {
      cov_1295o4djk3.f[22]++;
      cov_1295o4djk3.s[80]++;

      if (this.props.disabled === true) {
        cov_1295o4djk3.b[19][0]++;
        cov_1295o4djk3.s[81]++;
        return;
      } else {
        cov_1295o4djk3.b[19][1]++;
      }

      cov_1295o4djk3.s[82]++;

      if (focus === this.state.focus) {
        cov_1295o4djk3.b[20][0]++;
        cov_1295o4djk3.s[83]++;
        return;
      } else {
        cov_1295o4djk3.b[20][1]++;
      } // click close icon


      cov_1295o4djk3.s[84]++;

      if ((cov_1295o4djk3.b[22][0]++, focus) && (cov_1295o4djk3.b[22][1]++, e) && (cov_1295o4djk3.b[22][2]++, e.target.classList.contains(treeSelectClass('close')))) {
        cov_1295o4djk3.b[21][0]++;
        cov_1295o4djk3.s[85]++;
        return;
      } else {
        cov_1295o4djk3.b[21][1]++;
      }

      var _ref6 = (cov_1295o4djk3.s[86]++, this.props),
          _ref6$height = _ref6.height,
          height = _ref6$height === void 0 ? (cov_1295o4djk3.b[23][0]++, DefaultValue.height) : _ref6$height,
          onCollapse = _ref6.onCollapse;

      var _ref7 = (cov_1295o4djk3.s[87]++, this.props),
          position = _ref7.position;

      var windowHeight = (cov_1295o4djk3.s[88]++, docSize.height);
      var bottom = (cov_1295o4djk3.s[89]++, height + this.element.getBoundingClientRect().bottom);
      cov_1295o4djk3.s[90]++;

      if ((cov_1295o4djk3.b[25][0]++, bottom > windowHeight) && (cov_1295o4djk3.b[25][1]++, !position)) {
        cov_1295o4djk3.b[24][0]++;
        cov_1295o4djk3.s[91]++;
        position = 'drop-up';
      } else {
        cov_1295o4djk3.b[24][1]++;
      }

      cov_1295o4djk3.s[92]++;

      if (onCollapse) {
        cov_1295o4djk3.b[26][0]++;
        cov_1295o4djk3.s[93]++;
        onCollapse(focus);
      } else {
        cov_1295o4djk3.b[26][1]++;
      }

      cov_1295o4djk3.s[94]++;
      this.setState({
        focus: focus,
        position: (cov_1295o4djk3.b[27][0]++, position) || (cov_1295o4djk3.b[27][1]++, 'drop-down')
      });
      cov_1295o4djk3.s[95]++;

      if (focus) {
        cov_1295o4djk3.b[28][0]++;
        cov_1295o4djk3.s[96]++;
        this.bindClickAway(); // onFocus()
      } else {
        cov_1295o4djk3.b[28][1]++;
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      cov_1295o4djk3.f[23]++;
      cov_1295o4djk3.s[97]++;

      if (!this.shouldFocus(e.target)) {
        cov_1295o4djk3.b[29][0]++;
        cov_1295o4djk3.s[98]++;
        return;
      } else {
        cov_1295o4djk3.b[29][1]++;
      }

      cov_1295o4djk3.s[99]++;
      this.props.onFocus(e);
      cov_1295o4djk3.s[100]++;
      this.bindClickAway();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      cov_1295o4djk3.f[24]++;

      var _ref8 = (cov_1295o4djk3.s[101]++, this.props),
          onEnterExpand = _ref8.onEnterExpand;

      cov_1295o4djk3.s[102]++;

      if (e.keyCode === 13) {
        cov_1295o4djk3.b[30][0]++;
        cov_1295o4djk3.s[103]++;
        e.preventDefault(); // enter only can open

        cov_1295o4djk3.s[104]++;

        if (!this.state.focus) {
          cov_1295o4djk3.b[31][0]++;
          cov_1295o4djk3.s[105]++;

          if (typeof onEnterExpand === 'function') {
            cov_1295o4djk3.b[32][0]++;
            var canOpen = (cov_1295o4djk3.s[106]++, onEnterExpand(e));
            cov_1295o4djk3.s[107]++;

            if (canOpen === false) {
              cov_1295o4djk3.b[33][0]++;
              cov_1295o4djk3.s[108]++;
              return;
            } else {
              cov_1295o4djk3.b[33][1]++;
            }
          } else {
            cov_1295o4djk3.b[32][1]++;
          }

          cov_1295o4djk3.s[109]++;
          this.handleState(true);
        } else {
          cov_1295o4djk3.b[31][1]++;
        }
      } else {
        cov_1295o4djk3.b[30][1]++;
      } // fot close the list


      cov_1295o4djk3.s[110]++;

      if (e.keyCode === 9) {
        cov_1295o4djk3.b[34][0]++;
        cov_1295o4djk3.s[111]++;
        this.props.onBlur(); // e.preventDefault()

        cov_1295o4djk3.s[112]++;

        if (this.state.focus) {
          cov_1295o4djk3.b[35][0]++;
          cov_1295o4djk3.s[113]++;
          this.handleState(false, e);
        } else {
          cov_1295o4djk3.b[35][1]++;
          cov_1295o4djk3.s[114]++;
          this.clearClickAway();
        }
      } else {
        cov_1295o4djk3.b[34][1]++;
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(data) {
      cov_1295o4djk3.f[25]++;

      var _ref9 = (cov_1295o4djk3.s[115]++, this.props),
          datum = _ref9.datum;

      var dataKey = (cov_1295o4djk3.s[116]++, (cov_1295o4djk3.b[37][0]++, data) && (cov_1295o4djk3.b[37][1]++, datum.isUnMatch(data)) ? (cov_1295o4djk3.b[36][0]++, data.value) : (cov_1295o4djk3.b[36][1]++, datum.getKey(data)));
      cov_1295o4djk3.s[117]++;
      datum.set(dataKey, 0);
      cov_1295o4djk3.s[118]++;
      this.handleChange(data, datum.getKey(data));
    }
  }, {
    key: "handleChange",
    value: function handleChange(data, id) {
      cov_1295o4djk3.f[26]++;

      var _ref10 = (cov_1295o4djk3.s[119]++, this.props),
          datum = _ref10.datum,
          multiple = _ref10.multiple,
          disabled = _ref10.disabled,
          onChange = _ref10.onChange,
          onChangeAddition = _ref10.onChangeAddition;

      cov_1295o4djk3.s[120]++;

      if ((cov_1295o4djk3.b[39][0]++, disabled === true) || (cov_1295o4djk3.b[39][1]++, datum.isDisabled(id))) {
        cov_1295o4djk3.b[38][0]++;
        cov_1295o4djk3.s[121]++;
        return;
      } else {
        cov_1295o4djk3.b[38][1]++;
      }

      var current = (cov_1295o4djk3.s[122]++, datum.getDataById(id));
      cov_1295o4djk3.s[123]++;

      if (!multiple) {
        cov_1295o4djk3.b[40][0]++;
        cov_1295o4djk3.s[124]++;
        datum.setValue([]);
        cov_1295o4djk3.s[125]++;
        datum.set(datum.getKey(data), 1);
        cov_1295o4djk3.s[126]++;
        this.handleState(false);
      } else {
        cov_1295o4djk3.b[40][1]++;
      }

      var value = (cov_1295o4djk3.s[127]++, this.getValue());
      cov_1295o4djk3.s[128]++;

      if (onChange) {
        cov_1295o4djk3.b[41][0]++;
        cov_1295o4djk3.s[129]++;
        onChange(value, current, id ? (cov_1295o4djk3.b[42][0]++, ((cov_1295o4djk3.b[43][0]++, datum.getPath(id)) || (cov_1295o4djk3.b[43][1]++, {})).path) : (cov_1295o4djk3.b[42][1]++, undefined));
      } else {
        cov_1295o4djk3.b[41][1]++;
      }

      cov_1295o4djk3.s[130]++;

      if (typeof onChangeAddition === 'function') {
        cov_1295o4djk3.b[44][0]++;
        cov_1295o4djk3.s[131]++;
        onChangeAddition({
          data: this.getDataByValue(value),
          checked: multiple ? (cov_1295o4djk3.b[45][0]++, datum.get(id)) : (cov_1295o4djk3.b[45][1]++, undefined),
          current: current
        });
      } else {
        cov_1295o4djk3.b[44][1]++;
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      cov_1295o4djk3.f[27]++;

      var _ref11 = (cov_1295o4djk3.s[132]++, this.props),
          multiple = _ref11.multiple,
          onChangeAddition = _ref11.onChangeAddition;

      cov_1295o4djk3.s[133]++;
      this.props.datum.setValue([]);
      cov_1295o4djk3.s[134]++;
      this.props.onChange(multiple ? (cov_1295o4djk3.b[46][0]++, []) : (cov_1295o4djk3.b[46][1]++, ''));
      cov_1295o4djk3.s[135]++;

      if (typeof onChangeAddition === 'function') {
        cov_1295o4djk3.b[47][0]++;
        cov_1295o4djk3.s[136]++;
        onChangeAddition({
          data: multiple ? (cov_1295o4djk3.b[48][0]++, []) : (cov_1295o4djk3.b[48][1]++, null)
        });
      } else {
        cov_1295o4djk3.b[47][1]++;
      }

      cov_1295o4djk3.s[137]++;
      this.handleState(false);
      cov_1295o4djk3.s[138]++;
      this.element.focus();
    } // only as default renderResult

  }, {
    key: "renderItem",
    value: function renderItem(data) {
      cov_1295o4djk3.f[28]++;

      var _ref12 = (cov_1295o4djk3.s[139]++, this.props),
          renderItem = _ref12.renderItem;

      cov_1295o4djk3.s[140]++;
      return typeof renderItem === 'function' ? (cov_1295o4djk3.b[49][0]++, renderItem(data)) : (cov_1295o4djk3.b[49][1]++, data[renderItem]);
    }
  }, {
    key: "renderActive",
    value: function renderActive(data, expanded, active, id) {
      cov_1295o4djk3.f[29]++;

      var _ref13 = (cov_1295o4djk3.s[141]++, this.props),
          renderItem = _ref13.renderItem,
          datum = _ref13.datum;

      var item = (cov_1295o4djk3.s[142]++, typeof renderItem === 'function' ? (cov_1295o4djk3.b[50][0]++, renderItem(data, expanded, active, id)) : (cov_1295o4djk3.b[50][1]++, data[renderItem]));
      cov_1295o4djk3.s[143]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          title: typeof item === 'string' ? (cov_1295o4djk3.b[51][0]++, item) : (cov_1295o4djk3.b[51][1]++, undefined),
          className: treeSelectClass('content-wrapper', (cov_1295o4djk3.b[52][0]++, active) && (cov_1295o4djk3.b[52][1]++, 'selected'), (cov_1295o4djk3.b[53][0]++, datum.isDisabled(datum.getKey(data))) && (cov_1295o4djk3.b[53][1]++, getDirectionClass('disabled'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 309,
            columnNumber: 7
          }
        }, item)
      );
    }
  }, {
    key: "renderTreeOptions",
    value: function renderTreeOptions() {
      var _this4 = this;

      cov_1295o4djk3.f[30]++;

      var _ref14 = (cov_1295o4djk3.s[144]++, this.state),
          focus = _ref14.focus,
          position = _ref14.position;

      var _ref15 = (cov_1295o4djk3.s[145]++, this.props),
          multiple = _ref15.multiple,
          datum = _ref15.datum,
          data = _ref15.data,
          absolute = _ref15.absolute,
          height = _ref15.height,
          zIndex = _ref15.zIndex,
          compressed = _ref15.compressed,
          value = _ref15.value;

      var props = (cov_1295o4djk3.s[146]++, {});
      var TreeKeys = (cov_1295o4djk3.s[147]++, ['mode', 'data', 'datum', 'defaultExpanded', 'defaultExpandAll', 'disabled', 'expanded', 'keygen', 'loader', 'onExpand', 'renderItem', 'line', 'parentClickExpand', 'childrenKey', 'expandIcons']);
      cov_1295o4djk3.s[148]++;
      TreeKeys.forEach(function (k) {
        cov_1295o4djk3.f[31]++;
        ;
        cov_1295o4djk3.s[149]++;
        props[k] = _this4.props[k];
      });
      cov_1295o4djk3.s[150]++;
      props.value = datum.getValue();
      cov_1295o4djk3.s[151]++;

      if (multiple) {
        cov_1295o4djk3.b[54][0]++;
        cov_1295o4djk3.s[152]++;
        // @ts-ignore only use second param
        props.onChange = this.handleChange;
      } else {
        cov_1295o4djk3.b[54][1]++;
        cov_1295o4djk3.s[153]++;
        props.onClick = this.handleChange;
        cov_1295o4djk3.s[154]++;
        props.renderItem = this.renderActive;
        cov_1295o4djk3.s[155]++;
        props.active = props.value.length ? (cov_1295o4djk3.b[55][0]++, props.value[0]) : (cov_1295o4djk3.b[55][1]++, undefined);
      }

      var content = (cov_1295o4djk3.s[156]++, data.length === 0 ? (cov_1295o4djk3.b[56][0]++,
      /*#__PURE__*/
      React.createElement("span", {
        className: treeSelectClass(getDirectionClass('option')),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 358,
          columnNumber: 9
        }
      }, this.getText('noData'))) : (cov_1295o4djk3.b[56][1]++,
      /*#__PURE__*/
      React.createElement(Tree, Object.assign({
        className: treeSelectClass((cov_1295o4djk3.b[57][0]++, !multiple) && (cov_1295o4djk3.b[57][1]++, 'single'))
      }, props, {
        dataUpdate: false,
        onExpand: this.onExpandHandler,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 360,
          columnNumber: 9
        }
      }))));
      cov_1295o4djk3.s[157]++;
      return (
        /*#__PURE__*/
        React.createElement(OptionList, {
          getResetPosition: this.getResetPosition,
          absolute: absolute,
          rootClass: treeSelectClass(position, (cov_1295o4djk3.b[58][0]++, isRTL()) && (cov_1295o4djk3.b[58][1]++, 'rtl')),
          parentElement: this.element,
          position: position,
          focus: focus,
          "data-id": this.treeSelectId,
          className: treeSelectClass('options'),
          style: {
            maxHeight: height,
            overflowY: 'auto'
          },
          fixed: "min",
          zIndex: zIndex,
          value: (cov_1295o4djk3.b[60][0]++, multiple) && (cov_1295o4djk3.b[60][1]++, !compressed) ? (cov_1295o4djk3.b[59][0]++, value) : (cov_1295o4djk3.b[59][1]++, undefined),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 368,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: treeSelectClass('tree-wrapper'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 382,
            columnNumber: 9
          }
        }, content))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1295o4djk3.f[32]++;

      var _ref16 = (cov_1295o4djk3.s[158]++, this.props),
          placeholder = _ref16.placeholder,
          onFilter = _ref16.onFilter,
          compressed = _ref16.compressed,
          compressedBound = _ref16.compressedBound,
          multiple = _ref16.multiple,
          datum = _ref16.datum,
          clearable = _ref16.clearable,
          disabled = _ref16.disabled,
          size = _ref16.size,
          filterText = _ref16.filterText,
          result = _ref16.result,
          renderUnmatched = _ref16.renderUnmatched,
          innerTitle = _ref16.innerTitle,
          keygen = _ref16.keygen,
          data = _ref16.data;

      var className = (cov_1295o4djk3.s[159]++, treeSelectClass('inner', size, (cov_1295o4djk3.b[61][0]++, this.state.focus) && (cov_1295o4djk3.b[61][1]++, 'focus'), this.state.position, (cov_1295o4djk3.b[62][0]++, multiple) && (cov_1295o4djk3.b[62][1]++, 'multiple'), (cov_1295o4djk3.b[63][0]++, disabled === true) && (cov_1295o4djk3.b[63][1]++, getDirectionClass('disabled'))));
      var renderResult = (cov_1295o4djk3.s[160]++, (cov_1295o4djk3.b[64][0]++, this.props.renderResult) || (cov_1295o4djk3.b[64][1]++, this.renderItem));
      cov_1295o4djk3.s[161]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          // eslint-disable-next-line
          tabIndex: disabled === true ? (cov_1295o4djk3.b[65][0]++, -1) : (cov_1295o4djk3.b[65][1]++, 0),
          ref: this.bindElement,
          className: className,
          "data-id": this.treeSelectId,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onClick: this.handleClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 416,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Result, {
          filterText: filterText,
          onClear: clearable ? (cov_1295o4djk3.b[66][0]++, this.handleClear) : (cov_1295o4djk3.b[66][1]++, undefined),
          onRemove: this.handleRemove,
          onFilter: onFilter,
          result: result,
          disabled: disabled,
          datum: datum,
          focus: this.state.focus,
          multiple: multiple,
          placeholder: placeholder,
          renderResult: renderResult,
          setInputReset: this.setInputReset,
          compressed: compressed,
          compressedBound: compressedBound,
          renderUnmatched: renderUnmatched,
          innerTitle: innerTitle,
          keygen: keygen,
          data: data,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 426,
            columnNumber: 9
          }
        }), this.renderTreeOptions())
      );
    }
  }]);

  return TreeSelect;
}(PureComponent);

TreeSelect.defaultProps = DefaultValue;
export { TreeSelect as default };